import { APP_LOGO_SVG_PATH } from "../../assets/logo-path";
import { getBrandMode } from "../../config/brand-colors";
import { getWhiteLabelLogoUrl, usesCustomLogo } from "../../config/white-label";

const FAVICON_LINK_ID = "app-brand-favicon";

function buildLogoSvg(fillColor) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 40"><path d="${APP_LOGO_SVG_PATH}" fill="${fillColor}"/></svg>`;
}

function setLinkIcon(href, type = "image/svg+xml") {
  let link = document.getElementById(FAVICON_LINK_ID);

  if (!link) {
    link =
      document.querySelector('link[rel="icon"]') ??
      document.createElement("link");
    link.id = FAVICON_LINK_ID;
    link.rel = "icon";
    if (!link.parentElement) {
      document.head.appendChild(link);
    }
  }

  link.type = type;
  link.href = href;
}

function setThemeColorMeta(color) {
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "theme-color";
    document.head.appendChild(meta);
  }
  meta.content = color;
}

/**
 * Replaces static favicon.ico with an SVG generated from the app logo + brand color.
 * Also updates meta theme-color for mobile browser chrome.
 */
export function applyBrandFavicon(brand, isDarkMode) {
  const brandColor = getBrandMode(brand, isDarkMode).main;
  const customLogoUrl = getWhiteLabelLogoUrl();

  if (usesCustomLogo() && customLogoUrl) {
    setLinkIcon(customLogoUrl, "image/png");
  } else {
    const svg = buildLogoSvg(brandColor);
    const href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
    setLinkIcon(href);
  }

  setThemeColorMeta(brandColor);
}
